<template>
  <div class="charge" :style="{backgroundImage: !showErr ? 'url(' + bkgImg + ')' : ''}">
    <MaskLoading :showMask="isGloabLoading" />
    <template v-if="!showErr">
      <div class="title">
        <span>{{initData.title}}</span>
        <span @click="!$isIframe ? gotoRecord() : ''" :style="{ fontSize: '.12rem' }">充值记录</span>
      </div>
      <div class="content">
        <Account
          :isHistoryNo="isHistoryNo"
          v-if="initData.accountFloorInfo"
          :accoutData="initData.accountFloorInfo"
          :initValue="historyNo"
          v-on:changeAccount="changeAccount"
        />
        <template v-for="(item, idx) in initData.attributeFloorInfoList">
          <Floor
            :key="idx"
            :floorData="item"
            v-on:changeSelItem="changeSelItem"
          />
        </template>
        <van-cell
          v-if="initData.gameTempaltePreviewList.length > 0"
          class="game-sel"
          is-link :value="extGoodsName"
          @click="showGamePop=true"
        >
          <template #title>
            <span style="color: red;">*</span>
            <span class="custom-title">游戏区服</span>
          </template>
        </van-cell>
        <GameFloor
          :showGamePop="showGamePop"
          :dataList="initData.gameTempaltePreviewList"
          @selectItem="selectGameItem"
          @closeGamePop="closeGamePop"
        />
        <van-button
          class="submit-btn"
          @click="!$isIframe ? saveData() : ''"
          :loading="saveLoading"
          type="info"
          >立即充值</van-button>
      </div>
      <div class="text-container" v-if="contentText.length > 0">
        <!-- <div class="title" >{{contentTextTitle}}</div> -->
        <p v-for="(item, idx) in contentText" :key="idx">{{item}}</p>
      </div>
    </template>
    <template v-else>
      <div class="error-container">
        <img src="@/assets/img/ordernull.png" />
        <div class="text">{{errMsg || '系统更新维护中！'}}</div>
      </div>
    </template>
  </div>
</template>

<script>
import qs from 'qs'
import { getFloorData, getGoodsId, createVirtualOrder, mediaGetHistoryAccount } from '@/api/charge'
import Account from './comps/account'
import Floor from './comps/floor'
import GameFloor from './comps/gameFloor'
import axios from 'axios'
import apiConfig from '@/config/index' // 路径配置
import {
  Dialog, Toast
} from 'vant'
import { getCurrentDate } from '@/utils/util'
import { behaviorCollect } from '@/api/track'
export default {
  name: 'Home',
  components: {
    Account,
    Floor,
    GameFloor
  },
  data: () => {
    return {
      apiConfig,
      historyNo: '',
      isHistoryNo: false,
      isGloabLoading: false,
      initData: {
        attributeFloorInfoList: [],
        gameTempaltePreviewList: []
      },
      accountNum: '',
    //   couponGoods: {},
      quantity: '1',
      contentTextTitle: '', // 关联文案标题
      contentText: [], // 关联文案
      saveLoading: false,
      selectProps: [], // 选中的属性值
      mustPassIdx: '', // 是否通过上游获取产品信息索引
      chargeGame: '',
      chargeGameList: [],
      chargeGameIdx: 0,
      goodsId: '',
      showErr: false,
      bkgImg: require('@/assets/img/bkg-circle.png'),
      postArr: [],
      showGamePop: false,
      extGoodsName: '请选择' // 游戏区服
    }
  },
  created() {
    const { query } = this.$route
    this.query = query
    if (query.id) {
      // 获取首页渲染数据
      this.getFloorData({})
      this.getHistoryAccount()
    }
  },
  mounted() {
    this.sendBehaviorData()
  },
  methods: {
    getHistoryAccount() {
       mediaGetHistoryAccount({
        brandId: this.query.id
       }).then(res => {
          if (res.resultObj && res.resultCode == '0000') {
            this.isHistoryNo = true
            this.accountNum = res.resultObj
            this.historyNo = res.resultObj
          }
       })
    },
    // 关闭区服遮罩
    closeGamePop () {
      this.showGamePop = false
    },
    // 选择游戏区服
    selectGameItem (item) {
      this.extGoodsName = item
      this.closeGamePop()
    },
    // 跳转充值记录
    gotoRecord() {
      location.href = `${apiConfig.baseURL}/etonmall_h5/fulu/toHistoryPage.do`
    },
    // 获取首页渲染数据
    getFloorData(_param) {
        this.isGloabLoading = true
        const contextArr = []
        const contextTitleArr = []
        getFloorData({
            ..._param,
            brandId: this.query.id,
            needLogin: '1',
            isMiniApp: this.query.isMiniApp ? this.query.isMiniApp : ''
        }).then((res) => {
          // 9999 代表未登录，会由全局拦截器触发登录，这里直接退出以避免展示错误态
          if (!res || res.resultCode === '9999') {
            this.isGloabLoading = false
            return
          }
            this.showErr = false
            const result = res.resultObj || {}
            result.attributeFloorInfoList &&
            result.attributeFloorInfoList.forEach((item, idx) => {
                item.level = idx
                item.attributeFloorContentInfoList.forEach((item2, idx2) => {
                    if (!item.isRelation) { // 非关联属性，默认属性值为第一项
                        if (idx2 === 0) {
                          item2.active = true
                        }
                    }
                    if (item.mustPass === '1') { // 如是必填项，设置chargeGameIdx
                        if (item2.active) {
                            this.chargeGameIdx = idx2
                        } else {
                            this.chargeGameIdx = 0
                        }
                    }
                    if (item2.description && item2.description.length > 0 && item2.active) {
                        contextArr.push(item2.description)
                        contextTitleArr.push(item2.propertyValue)
                    }
                    if (item2.active && item2.number) { // 如果产品属性上有number，则取该值
                      this.quantity = item2.number
                    }
                })
            })
            setTimeout(() => {
              this.contentText = contextArr[0] || []
              this.contentTextTitle = contextTitleArr[0] || ''
              this.initData = result
            }, 0)
            this.isGloabLoading = false
        }).catch((e) => {
          this.showErr = true
          this.errMsg = e.resultMessage || '信息错误'
          this.isGloabLoading = false
        })
    },
    // 更新充值号码
    changeAccount(val) {
      this.accountNum = val
      this.isHistoryNo = false
      // this.historyNo = ''
    },
    // 提交数据前数据校验
    saveData() {
        const louceng2Data = JSON.parse(JSON.stringify(this.initData.attributeFloorInfoList))
        const temArr = []
        louceng2Data.forEach((item, idx) => {
            item.attributeFloorContentInfoList.forEach((item2, idx2) => {
                if (item2.active) {
                    temArr.push(item2.propertyValue)
                }
            })
        })
        // 获取商品Id
        this.getGoodsId(temArr)
    },
    // 获取goodsId
    getGoodsId (temArr) {
        this.postArr = temArr
        const param = {
            brandId: this.query.id,
            attrList: temArr,
            needLogin: '1'
        }
        this.saveLoading = true
        getGoodsId(param).then((res) => {
            this.saveLoading = false
            const result = res.resultObj || ''
            // this.couponGoods = result
            this.goodsId = result
            // 判断是否需要调取上游接口获取信息
            this.judgeNeedInfoFromThird()
        }).catch((e) => {
            this.saveLoading = false
            console.log(e)
        })
    },
    // 判断是否需要调取上游接口获取信息
    judgeNeedInfoFromThird () {
        const louceng2Data = JSON.parse(JSON.stringify(this.initData.attributeFloorInfoList))
        let prodId = ''
        louceng2Data.forEach((item, idx) => {
            if (item.mustPass === '1') {
                prodId = item.prodId
                this.mustPassIdx = idx
            }
        })
        if (prodId) {
            // 获取fulu产品信息
            this.getFuluGoodsInfo(prodId)
        } else {
            // 上送数据
            this.sendData()
        }
    },
    // 获取fulu产品信息
    getFuluGoodsInfo (prodId) {
        // const _url = 'https://www.fastmock.site/mock/af748780a9e203f4b86a59deefab2d17/multi-media/fulu/queryFuluProd.do'
        const _url = '/etonmall_h5/fulu/queryFuluProd.do'
        const param = {
            prodId
        }
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        this.saveLoading = true
        axios({
            url: _url,
            method: 'post',
            data: qs.stringify(param),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }).then(res => {
            this.saveLoading = false
            if (res && res.data && res.data.length > 0) {
                const result = res.data[0] || {}
                this.chargeGame = result.ChargeGame
                this.chargeGameList = result.GameList.ChargeType
                // 上送数据
                this.sendData()
            } else {
                Dialog({ message: '获取上游信息失败' })
            }
        }).catch(err => {
            this.saveLoading = false
            Dialog({ message: JSON.stringify(err) })
        })
    },
    sendData () {
        const templateId = this.query.id
        // const louceng2Data = JSON.parse(JSON.stringify(this.initData.attributeFloorInfoList))
        const param = {
            goodsId: this.goodsId,
            quantity: this.quantity,
            telNum: this.accountNum,
            templateId,
            ipAddress: returnCitySN.cip,
            attrList: this.postArr,
            extGoodsName: this.extGoodsName
        }
        if (!param.telNum) {
          Toast.fail('请输入充值账号！')
          return
        }
        if (this.initData.gameTempaltePreviewList.length > 0) {
          if (this.extGoodsName === '请选择') {
            Toast.fail('请选择游戏区服')
            return
          } else {
            const fullNameArr = this.extGoodsName.split('—')
            const obj = '"charge_game_name":"' + fullNameArr[0] + '","charge_game_region":"' + (fullNameArr[1] ? fullNameArr[1] : '') + '","charge_game_srv":"' + (fullNameArr[2] ? fullNameArr[2] : '') + '"'
            param.extra_data = '{' + obj + '}'
          }
        } else {
          delete param.extGoodsName
          if (this.chargeGame) {
              const chargeType = this.chargeGameList[this.chargeGameIdx].Name
              const obj = '"charge_game_name":"' + this.chargeGame + '","charge_type":"' + chargeType + '"'
              param.extra_data = '{' + obj + '}'
              // param.extra_data = `{"charge_game_name":"${this.chargeGame}","charge_type":"${chargeType}"}`
          } else {
            param.extra_data = null
          }
        }
        this.saveLoading = true
        createVirtualOrder(param).then((res) => {
            const result = res.resultObj || ''
            if (typeof appObj === 'undefined') {
                window.location.href = `${apiConfig.baseURL}/etonmall_h5/fulu/toPayConfirm.do?orderId=${result}`
            } else {
              appObj.appHrefBlank(
                `/fulu/toPayConfirm.do?orderId=${result}`
              )
            }
            this.saveLoading = false
        }).catch((e) => {
            console.log(e)
            this.saveLoading = false
        })
    },
    // 修改选中属性值
    changeSelItem(_data, key, item) {
        const { level, isRelation, propertyId } = _data
        console.log(level, key, item)
        const { propertyValue = '' } = item
        const louceng2Data = JSON.parse(JSON.stringify(this.initData.attributeFloorInfoList))
        if (isRelation) {
            // 如果选中的是关联属性，则重新获取楼层数据
            const _param = {
                propertyId,
                relationValue: propertyValue
            }
            this.getFloorData(_param)
        } else {
            louceng2Data.forEach((item) => {
                if (item.level === level) {
                    if (item.mustPass === '1') {
                        this.chargeGameIdx = key
                    }
                    item.attributeFloorContentInfoList.forEach((item2, idx2) => {
                        if (idx2 === key) {
                            item2.active = true
                            if (item2.number) { // 如果产品属性上有number，则取该值
                                this.quantity = item2.number
                            }
                            if (item2.description && item2.description.length > 0) { // 如果产品属性上有关联文本描述，则取该值
                                this.contentText = item2.description
                                this.contentTextTitle = item2.propertyValue
                            }
                        } else {
                            item2.active = false
                        }
                    })
                }
            })
            this.initData.attributeFloorInfoList = louceng2Data
        }
    },
    // 行为数据采集
    sendBehaviorData() {
      const params = {
        ip: returnCitySN.cip, // ip地址
        os: isIOS ? 'iphone' : 'android', // 系统名称
        occTime: getCurrentDate(), // 发生时间
        actionType: '1', // 动作类型 下单-9，访问-1，点击-2
        appName: 'app', // 系统名称：商城、app
        channelName: this.$store.getters.environmenta, // 渠道名称：公众号 wechat_mp 、微信小程序：wechat_miniapp 、app端：app
        busiCode: '020002', // 业务编码
        busiName: '视听游戏充值', // 业务名称
        busiDesc: '', // 业务描述
        transNo: '', // 行为流水号：无订单号传空字符串
        subjectCode: 'audiovisual_games', // 主体编码
        subjectName: '视听游戏充值', // 主体名称
        subjectAmt: '', // 产品金额（分为单位）
        lev1: '', // 一级类目
        lev2: '', // 二级类目
        lev3: '' // 三级类目
      }
      behaviorCollect(params).then(res => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.charge {
  width: 100%;
  min-height: 100%;
  // background: #fbfbfb url('~@/assets/img/bkg-circle.png') no-repeat top center;
  background: #fbfbfb no-repeat top center;
  background-size: 100% 2.3rem;
  overflow: hidden;
  .error-container{
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      // margin-top: 2.4rem;
      width: 2rem;
      margin-top: 1.01rem;
    }
    .text{
      margin-top: .58rem;
    }
  }
  .title {
    width: 3.55rem;
    height: 0.225rem;
    line-height: 0.225rem;
    display: flex;
    margin: 0.24rem auto 0;
    font-size: 0.16rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    justify-content: space-between;
  }
  .content {
    width: 3.55rem;
    margin: 0.2rem auto;
    border-radius: 8px;
    background-color: #ffffff;
    overflow: hidden;
    padding-bottom: 0.2rem;
    .submit-btn {
      width: 3.55rem;
      margin: 0.6rem auto;
      margin-bottom: 0;
      border-radius: 22.5px;
      font-size: 0.16rem;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .game-sel{
      margin-top: .2rem;
      .van-cell__title{
        display: flex;
        align-items: center;
        font-size: .15rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .van-cell__value{
        text-align: left;
        flex: 2;
      }
      .van-cell__right-icon{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .text-container {
    text-align: left;
    padding-bottom: 0.2rem;
    .title {
      height: 0.17rem;
      font-size: 0.12rem;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 0.17rem;
      margin-bottom: 0.04rem;
    }
    p {
      margin-top: 0.04rem;
      margin-left: 0.1rem;
      font-size: 0.14rem;
      color: #333333;
      line-height: 0.2rem;
    }
  }
}
</style>
